var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Rails entry point — `react_component 'Proposals/SaveAndSendModal', { ... }`.
//
// The implementation lives in SaveAndSendModalView.tsx (NOT named after the
// directory): webpack's require.context treats a sibling file named after its parent
// directory as a self-import, yielding an undefined export at runtime.
import React, { useEffect, useState } from 'react';
import SaveAndSendModalView from './SaveAndSendModalView';
export default function Index(_a) {
    var { triggerIds = [] } = _a, props = __rest(_a, ["triggerIds"]);
    const [isOpen, setIsOpen] = useState(false);
    // Rails hands a fresh array on every render; key the effect on its contents.
    const triggerKey = triggerIds.join(',');
    const { pdfPath } = props;
    useEffect(() => {
        const onClick = (event) => {
            event.preventDefault();
            setIsOpen(true);
        };
        // The preview is `view_and_accept.pdf`, generated on demand by wicked_pdf — roughly
        // 1.7s of server time. `Modal` renders nothing while closed, so without this the
        // request only starts on click and the pane sits empty for that long.
        //
        // The dialog this replaced had its <object> in the DOM from page load, so the
        // browser fetched the PDF whether or not anyone opened it. Prefetching on hover and
        // focus instead gets the same head start without spending a PDF render on every
        // visitor to the wizard's preview step.
        let prefetched = false;
        const prefetch = () => {
            if (prefetched || !pdfPath)
                return;
            prefetched = true;
            const link = document.createElement('link');
            link.rel = 'prefetch';
            link.as = 'document';
            link.href = pdfPath;
            document.head.appendChild(link);
        };
        const triggers = triggerKey
            .split(',')
            .filter(Boolean)
            .map((id) => document.getElementById(id))
            .filter((el) => el !== null);
        triggers.forEach((t) => {
            t.addEventListener('click', onClick);
            t.addEventListener('mouseenter', prefetch);
            t.addEventListener('focus', prefetch);
        });
        return () => triggers.forEach((t) => {
            t.removeEventListener('click', onClick);
            t.removeEventListener('mouseenter', prefetch);
            t.removeEventListener('focus', prefetch);
        });
    }, [triggerKey, pdfPath]);
    // eslint-disable-next-line react/jsx-props-no-spreading
    return React.createElement(SaveAndSendModalView, Object.assign({}, props, { isOpen: isOpen, onClose: () => setIsOpen(false) }));
}
